export default "__VITE_ASSET__C9UrYR6H__"